import {
  BusinessProfileOption,
  CompanyCreationModes,
  CompanyCreationSteps,
  FranchiseOption,
} from '../../../../../views/companies';
import { BusinessType } from '../../../../../services/exports/Constants';

export default {
  title: 'Nouveau restaurant',
  sections: {
    new_company: {
      titles: {
        [CompanyCreationModes.demo]: 'Nouvelle démo',
        [CompanyCreationModes.full]: 'Nouveau restaurant',
      },
      steps: {
        [CompanyCreationSteps.CompanyInfo]: 'Infos restaurant',
        [CompanyCreationSteps.BusinessInfo]: 'Infos société',
        [CompanyCreationSteps.AdditionalLocations]: 'Restaurants supplémentaires',
      },
    },
    business_profile: {
      legal_info: 'Infos légales',
      owner_info: 'Infos propriétaire',
    },
    recently_created: 'Récemment créés',
  },
  form: {
    franchise: {
      label: 'Créer un restaurant',
      tooltip:
        'Veuillez indiquer si vous créez une toute nouvelle marque ou si vous ajoutez ce restaurant à une marque déjà existante dans notre système.',
      options: {
        [FranchiseOption.CreateFranchise]: {
          title: 'Créer une nouvelle marque',
          tooltip: 'On part de zéro — aucune marque ni restaurant existant',
        },
        [FranchiseOption.UseExistingFranchise]: {
          title: 'Ajouter ce restaurant à une marque existante',
          tooltip: 'Elle appartient déjà à une marque présente dans le système',
        },
      },
    },
    restaurants: {
      label: 'Restaurant(s) associé(s)',
    },

    business_profile: {
      label: 'Qui est le propriétaire ?',
      tooltip:
        'Ce restaurant appartient-il à un propriétaire/société déjà présent dans notre système (ex. : « Luís Pizza GmbH ») ? <br/> Si oui, sélectionnez ce profil existant. Sinon, créez un nouveau profil propriétaire/société.',
      options: {
        [BusinessProfileOption.CreateBusinessProfile]: 'Créer un nouveau profil propriétaire/société',
        [BusinessProfileOption.UseExistingBusinessProfile]: 'Utiliser un profil propriétaire/société existant',
      },
    },
    business_type: {
      label: "Type d'entreprise",
      placeholder: "Sélectionner le type d'entreprise",
      options: {
        [BusinessType.Company]: 'Société',
        [BusinessType.Individual]: 'Auto-entrepreneur',
      },
    },
    display_name: {
      label: 'Nom du restaurant',
      placeholder: "Nom d'affichage",
    },
    legal_name: {
      label: 'Raison sociale',
      placeholder: 'Raison sociale',
    },
    owner_first_name: {
      label: 'Prénom du contact',
      placeholder: 'James',
    },
    owner_last_name: {
      label: 'Nom de famille du contact',
      placeholder: 'Bond',
    },
    owner_phone_number: {
      label: 'Téléphone du contact',
      placeholder: '1785080120',
    },
    owner_email: {
      label: 'E-mail du contact',
      placeholder: "Saisir l'e-mail",
    },
    password: {
      label: 'Mot de passe',
      placeholder: 'Saisir le mot de passe',
    },

    additional_companies: {
      label: 'Restaurants supplémentaires sous cette marque',
      tooltip:
        "Y a-t-il des restaurants supplémentaires sous la même marque que {{company}} ? <br/> Si oui, cliquez sur « Ajouter un restaurant » pour inclure d'autres établissements. S'il s'agit du même propriétaire mais d'une marque différente, ne l'ajoutez pas ici. Créez-le séparément.",
    },
  },
  labels: {
    create_demo: 'Créer une démo',
    create_company: 'Créer un restaurant',
    business_type: "Type d'entreprise",
    display_name: "Nom d'affichage",
    legal_name: 'Raison sociale',
    owner_name: 'Nom du propriétaire',
    address: 'Adresse',
  },
  fields: {
    name: 'Nom',
    created_at: 'Créé',
    actions: 'Actions',
  },

  buttons: {
    add_restaurant: '+ Ajouter un restaurant',
    continue: 'Continuer',
    back: 'Retour',
    create: 'Créer un restaurant',
    delete: 'Supprimer',
  },
  popups: {
    delete_demo: {
      title: 'Confirmer la suppression ?',
    },
  },
  toasts: {
    company_created: 'Restaurant créé avec succès',
    failed_to_create_company: 'Échec de la création du restaurant',
    failed_to_delete_demo: 'Échec de la suppression de la démo',
    demo_got_deleted: 'Démo supprimée avec succès',
    failed_to_load_recently_created_companies: 'Échec du chargement des restaurants récemment créés',
  },
};
